import { Modal, Button, Spinner } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api_url } from "../../constant/constant";
import './AddUser.css';
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";
import { Tab, Tabs } from "react-bootstrap";

const AddUser = ({ onfetchUsers }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false); // Loader state
    const [departments, setDepartments] = useState([]);
    const [roles, setRoles] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
 
    useEffect(() => {
        fetchRoles();
        fetchDepartments();
    }, []);

    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone_number: "",
        username: "",
        password: "",
        role_id: "",
        department_id: "",
        error: ""
    });

    // Input change handler with .com validation
    const handleChange = (e) => {
        const { name, value } = e.target;
        let error = "";

        if (name === "email") {
            const dotComCount = (value.match(/\.com/g) || []).length;
            if (dotComCount > 1) {
                error = "Only one '.com' is allowed in the email";
            }
        }

        setFormData({
            ...formData,
            [name]: value,
            error,
        });
    };

    const fetchDepartments = async () => {
        try {
            const token = localStorage.getItem("userToken");
            const response = await fetch(api_url + '/departments/all', {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                }
            });
    
            if (!response.ok) {
                showToast(t("errorFetchingDepartments"), "error");
                return;
            }
    
            const departmentsData = await response.json();
            setDepartments(departmentsData);
        } catch (err) {
            showToast(t("somethingWentWrong"), "error");
        }
    };
    
    const fetchRoles = async () => {
        try {
            const token = localStorage.getItem("userToken");
            const response = await fetch(api_url + '/admin/main/user/roles', {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                }
            });

            if (!response.ok) {
                showToast(t("errorFetchingRoles"), "error");
                return;
            }
              
            const rolesData = await response.json();
            setRoles(rolesData);
        } catch (err) {
            showToast(t("somethingWentWrong"), "error");
        }
    };

    const handleAddUser = async (e) => {
        e.preventDefault();

        // ✅ Agar email me error hai to API stop
        if (formData.error) {
            showToast(formData.error, "error");
            return;
        }

        setIsLoading(true); // Loader start
    
        try {
            const token = localStorage.getItem("userToken");
            const response = await fetch(api_url + "/users", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
                redirect: "follow"
            });
    
            const data = await response.json();
    
            if (response.ok) {
                setFormData({
                  firstname: "",
                  lastname: "",
                  email: "",
                  phone_number: "",
                  username: "",
                  password: "",
                  role_id: "",
                  department_id: "",
                  error: ""
                });
              
                navigate(-1);
                handleClose();
                showToast(t("userAddedSuccessfully"), "success");
            } else {
                if (data.errors) {
                    Object.keys(data.errors).forEach((field) => {
                        data.errors[field].forEach((errMsg) => {
                            showToast(errMsg, "error");
                        });
                    });
                    handleClose();
                } else if (data.message) {
                    showToast(t(data.message) || data.message, "error");
                }
            }
        } catch (error) {
            showToast(t("somethingWentWrong"), "error");
            handleClose();
        } finally {
            setIsLoading(false); // Loader stop
        }
    };
    

    return (
        <div className="addEmailContainer" style={{ border: '1px solid #EAEAEA', borderRadius: '10px', padding: '26px 26px', margin: '20px' }}>

            <div className="d-flex justify-content-between mb-3">
                <div className="pageTitle">{t('AddUser')}</div>
                <Button variant="primary" onClick={() => navigate(-1)} >{t('Back')}</Button>
            </div>

            <Tabs defaultActiveKey="AddUser" className="mb-3">
                <Tab eventKey="AddUser" title={t("AddUser")}>
                    <form onSubmit={handleAddUser} className="addEmailForm">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('FirstName')}</label>
                                    <input type="text" autoComplete="off" name="firstname" className="form-control" onChange={handleChange} value={formData.firstname} required />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('LastName')}</label>
                                    <input type="text" autoComplete="off" name="lastname" className="form-control" onChange={handleChange} value={formData.lastname} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">{t('Email')}</label>
                              <input
                                type="email"
                                autoComplete="off"
                                name="email"
                                className={`form-control ${formData.error ? "is-invalid" : ""}`}
                                onChange={handleChange}
                                value={formData.email}
                                required
                              />
                              {formData.error && (
                                <div className="invalid-feedback">{formData.error}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">{t('PhoneNumber')}</label>
                              <input
                                  type="text"
                                  autoComplete="off"
                                  name="phone_number"
                                  className="form-control"
                                  maxLength={15}
                                  onChange={(e) => {
                                      if (e.target.value.length <= 15) {
                                          handleChange(e);
                                      }
                                  }}
                                  value={formData.phone_number}
                                  required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('Username')}</label>
                                    <input type="text" autoComplete="off" name="username" className="form-control" onChange={handleChange} value={formData.username} required />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('Password')}</label>
                                    <input autoComplete="off" type="password" name="password" className="form-control" onChange={handleChange} value={formData.password} required minLength={8}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('Role')}</label>
                                    <select className="form-select" aria-label="Admin" name="role_id" onChange={handleChange} required>
                                        <option value="">{t('SelectRole')}</option>
                                        {roles.map(role => (
                                            <option key={role.id} value={role.id} disabled={role.id === 1}>{role.title}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label">{t('Department')}</label>
                                    <select
                                        className="form-select"
                                        name="department_id"
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">{t('Select Department')}</option>
                                        {departments.map((dept) => (
                                            <option key={dept.id} value={dept.id}>
                                                {dept.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="text-end">
                            <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                {isLoading ? (
                                    <>
                                        <Spinner animation="border" size="sm" role="status" className="me-2" />
                                        {t('Adding...')}
                                    </>
                                ) : (
                                    t('AddUser')
                                )}
                            </button>
                        </div>
                    </form>
                </Tab>
            </Tabs>
        </div>
    );
}

export default AddUser;
